import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { RecoveryPointsSearchResultComponent } from './RecoveryPointsSearchResultComponent';

import recoveryPointsStore from '../../stores/RecoveryPointsStore';
import useFilters from './hooks/useFilters';
import { getCoordinates } from './helpers';
import useModals from './hooks/useModals';
import { RecoveryStoreReturnType } from './types';

type PointsRecoverySearchResultContainerProps = {
  latitude?: string;
  longitude?: string;
  date?: string;
  title?: string;
  locationIds?: string;
  city?: string;
  department?: string;
  filterButton: Element | null;
  mapButton: Element | null;
  isCityPage?: boolean;
  cityCenter?: {
    latitude: string;
    longitude: string;
  };
};

const RecoveryPointsSearchResultContainer = observer(
  ({
    latitude,
    longitude,
    date,
    title,
    locationIds,
    city,
    filterButton,
    mapButton,
    isCityPage,
    cityCenter,
  }: PointsRecoverySearchResultContainerProps) => {
    const [page, setPage] = useState(1);
    const [coordinates, setCoordinates] = useState<string[][]>([]);

    const latLng = cityCenter
      ? { latitude: cityCenter.latitude, longitude: cityCenter.longitude }
      : { latitude, longitude };
    const { filterModalVisible, mapModalVisible, toggleModal } = useModals(filterButton, mapButton);

    let selectedDate = date;
    if (!date) {
      [selectedDate] = new Date().toISOString().split('T');
    }

    const { points, total, isPointsDataLoading, departmentFilters } =
      recoveryPointsStore as RecoveryStoreReturnType;

    const {
      selectedDepartments,
      selectedPairs,
      handleDepartmentCheckboxChange,
      handleDaysCheckboxChange,
      dayPairs,
      selectedSort,
      SORT_BY,
      handleSortChange,
      handleDateChange,
    } = useFilters(
      recoveryPointsStore,
      latLng.latitude,
      latLng.longitude,
      selectedDate,
      page,
      '50',
      locationIds
    );

    const LIMIT = 8;
    const PAGES = Math.ceil(total / LIMIT);
    const placeTitle = title || city || '';

    const handlePageChange = (currentPage: number) => {
      setPage(currentPage);
      window.scrollTo(0, 0);
    };

    useEffect(() => {
      if (points.length > 0) {
        const coords = getCoordinates(points);
        setCoordinates(coords);
      }
    }, [points]);

    return (
      <RecoveryPointsSearchResultComponent
        handlePageChange={handlePageChange}
        activePage={page}
        totalPages={PAGES}
        totalPoints={total}
        points={points}
        isPointsDataLoading={isPointsDataLoading}
        departmentFilters={departmentFilters}
        dayPairs={dayPairs}
        handleDaysCheckboxChange={handleDaysCheckboxChange}
        handleDepartmentCheckboxChange={handleDepartmentCheckboxChange}
        selectedPairs={selectedPairs}
        selectedDepartments={selectedDepartments}
        selectedSort={selectedSort}
        handleSortChange={handleSortChange}
        SORT_BY={SORT_BY}
        latitude={latLng.latitude}
        longitude={latLng.longitude}
        coordinates={coordinates}
        selectedDate={selectedDate}
        placeTitle={placeTitle}
        filterModalVisible={filterModalVisible}
        mapModalVisible={mapModalVisible}
        toggleModal={toggleModal}
        isCityPage={isCityPage}
        handleDateChange={handleDateChange}
      />
    );
  }
);

export { RecoveryPointsSearchResultContainer };
